import { faLockOpen } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'styled-components'

import { Duration, FormattedMessage } from '@b-stock/fe-core/bstock-react'
import { Colors, Typography } from '@b-stock/fe-core/design-system'

import type { SearchResult } from '@/queries/listingSearchQuery'

import { useCardFirstDibsWindowEnd } from './useCardFirstDibsWindow'

// Matches the First Dibs ALP design (no design-system token for #A6BDFF).
const DIVIDER_COLOR = '#A6BDFF'

const Row = styled.div`
  ${Typography.Body3}
  display: flex;
  align-items: center;
  gap: 0.25rem;
  width: 100%;
  padding-top: 0.625rem;
  border-top: 1px dashed ${DIVIDER_COLOR};
  color: ${Colors.Semantic.BStock.default.lightBackground};
  font-weight: 600;
`

/**
 * "Opens to all buyers in …" while the buyer's First Dibs window is open.
 * Hides itself when the window closes; renders nothing with the flag off.
 */
const FirstDibsOpensIn = ({ listing }: { listing: SearchResult }) => {
  const windowEnd = useCardFirstDibsWindowEnd(listing)

  if (!windowEnd) return null

  return (
    <Row data-testid="first-dibs-opens-in">
      <FontAwesomeIcon icon={faLockOpen} size="xs" />
      <FormattedMessage
        id="FirstDibs.card.opensToAllBuyersIn"
        values={{
          duration: (
            <Duration key="duration" target={windowEnd} format="short" />
          ),
        }}
      />
    </Row>
  )
}

export default FirstDibsOpensIn
